import { TRIAL_DAYS } from './plans';

export const FAQS = [
  {
    q: 'What is TradeHive AI?',
    a: 'TradeHive AI is an AI-assisted market research workspace for stock and options traders. It combines market data, technical indicators, options flow, a daily market snapshot and AI-written explanations, so you can see the data behind every signal and judge it yourself.',
  },
  {
    q: 'Does TradeHive AI give investment advice?',
    a: 'No. TradeHive AI is for research and educational purposes only. It does not provide investment, legal or tax advice, and nothing in the product is a recommendation to buy or sell any security. All decisions are your own.',
  },
  {
    q: 'What tools are included?',
    a: 'AI Search outlooks (score, probability, drivers, key levels and risks with a chart), an options flow board, the Daily Market Snapshot, peer comparison, watchlists and alerts, and a track record that grades past outlooks against what price actually did.',
  },
  {
    q: 'How should I use AI insights?',
    a: 'Treat each outlook as one input to your own research. Check the drivers and levels against the chart, read what would invalidate the view, consider your own goals and risk tolerance, and verify anything important before acting.',
  },
  {
    q: 'Can the AI or the market data be wrong?',
    a: 'Yes. Market data can be delayed, incomplete or contain errors, and AI-written analysis can misread context. Scores and probabilities are estimates from past data, not predictions you can rely on. Always verify information independently.',
  },
  {
    q: 'How does the free trial work?',
    a: `The free trial lasts ${TRIAL_DAYS} days and includes full access to the workspace. A payment card is required to start. If you do not cancel during the trial, billing for the plan you chose begins on day ${TRIAL_DAYS + 1}. You can cancel anytime; see the Pricing page for current prices.`,
  },
  {
    q: 'Is the market data delayed?',
    a: 'The ticker tape on our public pages shows quotes delayed by at least 15 minutes, with the time of the last quote. Inside the app, prices, options and news come from Polygon.io; depending on the feed and market hours some data may be delayed, and panels show an "as of" time so you know how fresh it is.',
  },
  {
    q: 'How are signals calculated?',
    a: 'Indicators such as RSI, EMAs, MACD, relative volume and ATR are calculated in code from daily price data. They feed a 0 to 100 score built from momentum, trend, volume and volatility (plus options flow or mean-reversion inputs, depending on the strategy). Entry, target and stop come from the latest close and ATR. The AI then writes the explanation, and the numbers it uses are checked against the calculated data. See Methodology for details.',
  },
];
